module.exports = "<video id=\"movie\" preload loop>\n  <source src=\"http://static-cdn.universarium.org/video_fragments/10081/mp4/03RusAtomPromo_720p.mp4\" type=\"video/mp4\">\n</video>"


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/src/app/video/video.component.html
// module id = ../../../../../src/app/video/video.component.html
// module chunks = 1